<template>
  <div class="mb-2 d-flex align-center">
    <div class="mr-2" v-if="toggleview !== 3" @click="emitOpenWorkflows">
      <v-chip
        label
        small
        color="success"
        class="pl-2 cursor-pointer"
        v-if="showClosedChip"
        data-testid="ru-action-toolbar__closed-chip"
      >
        Closed
      </v-chip>
      <v-chip
        v-else
        label
        small
        color="info"
        class="pl-2 cursor-pointer"
        data-testid="ru-action-toolbar__open-chip"
      >
        Open
      </v-chip>
    </div>

    <div class="mr-2" @click="emitOpenUserList">
      <v-chip
        label
        small
        class="pl-2 cursor-pointer"
        color="success"
        v-if="isregionalapprover || toggleview === 3"
        data-testid="ru-action-toolbar__regional-approver-chip"
      >
        {{ $nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver') }}
      </v-chip>
      <v-chip
        label
        small
        class="pl-2 cursor-pointer"
        color="info"
        v-else-if="ispreparer"
        data-testid="ru-action-toolbar__local-preparer-chip"
      >
        {{ $nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer') }}
      </v-chip>
      <v-chip
        label
        small
        class="pl-2 cursor-pointer"
        color="warning"
        v-else-if="isapprover"
        data-testid="ru-action-toolbar__local-approver-chip"
      >
        {{ $nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver') }}
      </v-chip>
      <v-chip
        label
        small
        class="pl-2 cursor-pointer"
        v-else-if="ismanager"
        data-testid="ru-action-toolbar__manager-chip"
      >
        Manager
      </v-chip>
      <v-chip
        label
        small
        color="error"
        class="pl-2 cursor-pointer"
        v-else-if="isviewonly"
        data-testid="ru-action-toolbar__view-only-chip"
      >
        View Only
      </v-chip>
    </div>

    <v-menu
      v-if="toggleview !== 3"
      offset-y
      transition="slide-y-transition"
      :close-on-content-click="false"
      dense
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          inset
          class="shadow-off"
          name="filter-status"
          v-bind="attrs"
          v-on="on"
          data-testid="ru-action-toolbar__filter-btn"
        >
          <span class="text-capitalize">Filter</span>
          <v-icon class="ml-1">mdi-filter-menu</v-icon>
        </v-btn>
      </template>
      <div class="white">
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="info"
            dense
            hide-details
            class="mr-4 pa-0"
            label="Select All"
            name="select-all"
            v-model="selectedFilterProxy"
            value="all"
            @change="emitSelectAllFilters"
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="info"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited', 'Local commentary awaited')"
            name="local-commentary-awaited"
            v-model="selectedFilterProxy"
            :value="0"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="warning"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaiting_approval', 'Local commentary awaiting approval')"
            name="local-commentary-awaited-approval"
            v-model="selectedFilterProxy"
            :value="1"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="error"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_rejected', 'Local Commentary rejected')"
            name="local-commentary-rejected"
            v-model="selectedFilterProxy"
            :value="-1"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="info"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_awaited', 'Regional commentary awaited')"
            name="regional-commentary-awaited"
            v-model="selectedFilterProxy"
            :value="5"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="warning"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_awaiting_approval', 'Regional Commentary awaiting approval')"
            name="regional-commentary-awaited-approval"
            v-model="selectedFilterProxy"
            :value="6"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="error"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_rejected', 'Regional commentary rejected')"
            name="regional-commentary-rejected"
            v-model="selectedFilterProxy"
            :value="-2"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="success"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_approved_label', 'Approved Commentary')"
            name="approved-commentary"
            v-model="selectedFilterProxy"
            :value="7"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="grey"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_immaterial_variance_label', 'Immaterial variance')"
            name="immaterial-variance"
            v-model="selectedFilterProxy"
            :value="4"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="grey"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_nil_value_accounts_label', 'Nil value accounts')"
            name="nil-values"
            v-model="selectedFilterProxy"
            :value="3"
            multiple
          />
        </div>
        <div class="hoverable px-2 py-1">
          <v-checkbox
            color="grey"
            dense
            hide-details
            class="mr-4 pa-0"
            :label="$nova.labelsName('cycle_page', 'commentary_filter_not_in_scope_label', 'Not in Scope')"
            name="not-in-scope"
            v-model="selectedFilterProxy"
            :value="9"
            multiple
          />
        </div>
      </div>
    </v-menu>

    <v-switch
      dense
      small
      inset
      class="ml-4 mr-0 mt-0"
      name="toggle-custom-view"
      v-model="customFiltersToggleProxy"
      label="Custom View"
      hide-details
    />

    <div class="ml-4">
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="shadow-off"
            x-small
            @click="emitToggleView"
          >
            <v-icon small>
              {{ isCommentaryView ? 'mdi-playlist-star' : 'mdi-view-dashboard-edit-outline' }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ isCommentaryView ? 'List View' : 'Commentary View' }}</span>
      </v-tooltip>
      <v-spacer />
    </div>

    <span class="ml-4" v-if="toggletableview === 1">
      <v-select
        dense
        small
        hide-details
        :items="cycletypeItem"
        label="Comparison"
        solo
        item-text="text"
        item-value="value"
        v-model="cycletypeReadviewProxy"
      />
    </span>

    <v-spacer />

    <v-tooltip
      bottom
      content-class="tooltip-bottom"
      v-if="ispreparer && (ispendinglocalruapproval || ispendingregionalruapproval)"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          small
          name="import-commentary"
          @click="emitGetPreviousCycleList"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span v-if="workflows.islocalenabled">Import commentary from previous period</span>
      <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
    </v-tooltip>

    <div class="d-flex align-center" v-if="(multiselectdata || []).length > 1">
      <v-tooltip
        bottom
        content-class="tooltip-bottom"
        v-if="(isapprover && (ispendinglocalruapproval || !workflows.isregionalenabled)) || isregionalapprover"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            small
            name="bulk-request-commentary"
            @click="emitPerformBulkTask('request')"
          >
            <v-icon>mdi-comment-plus</v-icon>
          </v-btn>
        </template>
        <span
          v-if="(isapprover && workflows.islocalenabled) || (isregionalapprover && workflows.isregionalenabled)"
        >
          Request Commentary for Selected
        </span>
        <span v-else>
          <span v-if="isapprover">{{ commentary_local_key_label }}</span>
          <span v-else>{{ commentary_regional_key_label }}</span>
          {{ workflowsDisabledMessage }}
        </span>
      </v-tooltip>

      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            name="bulk-add-commentary"
            @click="emitPreviewBulkCommentary"
          >
            <v-icon>mdi-cloud-upload</v-icon>
          </v-btn>
        </template>
        <span v-if="ispreparer && !workflows.islocalenabled">
          {{ commentary_local_key_label }} {{ workflowsDisabledMessage }}
        </span>
        <span v-else>Submit Draft Commentary</span>
      </v-tooltip>

      <v-tooltip bottom content-class="tooltip-bottom" v-if="ispreparer">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            small
            name="bulk-add-commentary"
            @click="emitPerformBulkTask('addlocal')"
          >
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
        </template>
        <span v-if="ispreparer && !workflows.islocalenabled">
          {{ commentary_local_key_label }} {{ workflowsDisabledMessage }}
        </span>
        <span v-else>Add Commentary to Selected</span>
      </v-tooltip>

      <v-tooltip bottom content-class="tooltip-bottom" v-if="isapprover">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            small
            name="bulk-approve-reject"
            @click="emitPerformBulkTask('approvelocal')"
          >
            <v-icon>mdi-check-circle</v-icon>
          </v-btn>
        </template>
        <span v-if="workflows.islocalenabled">
          {{ commentary_local_key_label }} Approve/Reject all Selected
        </span>
        <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
      </v-tooltip>

      <v-tooltip
        bottom
        content-class="tooltip-bottom"
        v-if="isregionalapprover && cyclestage === 0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            small
            name="bulk-approve-reject"
            @click="emitPerformBulkTask('approveregional')"
          >
            <v-icon>mdi-check-circle</v-icon>
          </v-btn>
        </template>
        <span v-if="workflows.isregionalenabled">
          {{ commentary_regional_key_label }} Approve/Reject all Selected
        </span>
        <span v-else>Regional {{ workflowsDisabledMessage }}</span>
      </v-tooltip>
    </div>

    <v-tooltip
      bottom
      content-class="tooltip-bottom"
      v-if="toggleview !== 3 && toggletableview !== 1"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          icon
          class=""
          name="download-excel"
          target="_blank"
          @click="emitDownloadExcel"
        >
          <v-icon>mdi-file-excel-outline</v-icon>
        </v-btn>
      </template>
      <span>Download Excel</span>
    </v-tooltip>

    <v-tooltip
      bottom
      content-class="tooltip-bottom"
      v-if="toggleview !== 3 && toggletableview !== 1"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          icon
          class=""
          name="download-pdf"
          target="_blank"
          @click="emitGetPdf"
        >
          <v-icon>mdi-presentation</v-icon>
        </v-btn>
      </template>
      <span>Download PDF</span>
    </v-tooltip>

    <div v-if="toggletableview !== 1">
      <div v-if="workflowtext.length !== 8">
        <lb-conversation
          v-if="toggleview !== 3"
          heading="Conversation"
          width="600"
          :recurring="false"
          :recurringText="''"
          :closed="cyclestage === 1 || isviewonly || workflowtext.length === 8"
          :highlight="!conversationRead"
          @markread="handleMarkRead"
          :notify="!conversationRead"
          :getapi="`/v3/varianceanalysis/analysis/getconversation/${commentarycycledata._id}`"
          :sendapi="`/v3/varianceanalysis/analysis/addconversation/${commentarycycledata._id}`"
          :readapi="`/v3/varianceanalysis/analysis/markreadconversation/${commentarycycledata._id}`"
          :showprofile="false"
        />
      </div>
      <div v-else>
        <v-tooltip bottom content-class="tooltip-bottom">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="" name="conversations" v-bind="attrs" v-on="on" icon small>
              <v-icon class="">mdi-comment-text-multiple</v-icon>
            </v-btn>
          </template>
          <span>{{ workflowsDisabledMessage }}</span>
        </v-tooltip>
      </div>
    </div>

    <v-tooltip v-if="ispreparer" left content-class="tooltip-left">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          icon
          class=""
          name="bulk-commentary-file-upload"
          @click="emitBulkCommentaryDialogueOpen"
        >
          <v-icon>mdi-file-upload</v-icon>
        </v-btn>
      </template>
      <span v-if="workflows.islocalenabled">Bulk Submit Commentary</span>
      <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
    </v-tooltip>

    <v-tooltip v-if="isapprover" left content-class="tooltip-left">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          icon
          class=""
          name="bulk-commentary-file-upload"
          @click="emitBulkCommentaryDialogueOpenApprover"
        >
          <v-icon>mdi-file-chart-outline</v-icon>
        </v-btn>
      </template>
      <span v-if="workflows.islocalenabled">Bulk Submit Commentary</span>
      <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
    </v-tooltip>

    <v-tooltip
      v-if="(isapprover || isregionalapprover) && toggleview !== 3 && toggletableview !== 1"
      left
      content-class="tooltip-left"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          icon
          class=""
          name="bulk-commentary-file-upload"
          @click="emitBulkApproveDialogueOpen"
        >
          <v-icon>mdi-file-upload</v-icon>
        </v-btn>
      </template>
      <span
        v-if="(isapprover && workflows.islocalenabled) || (isregionalapprover && workflows.isregionalenabled)"
      >
        Bulk Approve/Reject Local Commentary
      </span>
      <span v-else>
        <span v-if="isapprover">{{ commentary_local_key_label }}</span>
        <span v-else>{{ commentary_regional_key_label }}</span>
        {{ workflowsDisabledMessage }}
      </span>
    </v-tooltip>

    <lb-activitylog
      v-if="toggleview !== 3 && toggletableview !== 1"
      :config="activitylogconfigcycle"
      :url="`/v3/varianceanalysis/analysis/getlogs/${commentarycycledata._id}/f/${commentarycycledata.type}`"
      contentClass="tooltip-bottom-right"
    />

    <div class="radius-small border-on ml-1" v-if="toggleview === 3 && pagecount > 1">
      <v-btn icon small :disabled="page <= 1" @click="goToPreviousPage">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="mx-1">Page {{ page }} of {{ pagecount }}</span>
      <v-btn icon small :disabled="page >= pagecount" @click="goToNextPage">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RUActionToolbar',
  props: {
    toggleview: { type: Number, default: 0 },
    workflows: { type: Object, default: () => ({}) },
    commentarycycledata: { type: Object, default: () => ({}) },
    commentary_local_key_label: { type: String, default: '' },
    commentary_regional_key_label: { type: String, default: '' },
    workflowsDisabledMessage: { type: String, default: '' },
    ispreparer: { type: Boolean, default: false },
    isapprover: { type: Boolean, default: false },
    isregionalapprover: { type: Boolean, default: false },
    ismanager: { type: Boolean, default: false },
    isviewonly: { type: Boolean, default: false },
    selectedfilter: { type: Array, default: () => [] },
    customfilterstoggle: { type: Boolean, default: false },
    cycletypeItem: { type: Array, default: () => [] },
    cycletypeReadview: { type: String, default: '' },
    isCommentaryView: { type: Boolean, default: false },
    ispendinglocalruapproval: { type: Boolean, default: false },
    ispendingregionalruapproval: { type: Boolean, default: false },
    multiselectdata: { type: Array, default: () => [] },
    workflowtext: { type: [String, Array], default: '' },
    toggletableview: { type: Number, default: 0 },
    cyclestage: { type: Number, default: 0 },
    activitylogconfigcycle: { type: Object, default: () => ({}) },
    page: { type: Number, default: 1 },
    pagecount: { type: Number, default: 1 },
  },
  computed: {
    selectedFilterProxy: {
      get() {
        return this.selectedfilter;
      },
      set(value) {
        this.$emit('update:selectedfilter', value);
      },
    },
    customFiltersToggleProxy: {
      get() {
        return this.customfilterstoggle;
      },
      set(value) {
        this.$emit('update:customfilterstoggle', value);
      },
    },
    cycletypeReadviewProxy: {
      get() {
        return this.cycletypeReadview;
      },
      set(value) {
        this.$emit('update:cycletypeReadview', value);
      },
    },
    conversationRead() {
      return Boolean(this.commentarycycledata && this.commentarycycledata.conversation_read);
    },
    showClosedChip() {
      const cycle = this.commentarycycledata || {};
      const wf = this.workflows || {};
      const localApproved = cycle?.local_ru_approve === true;
      const regionalApproved = cycle?.regional_ru_approve === true;
      if (localApproved && regionalApproved) {
        return true;
      }
      if (regionalApproved && wf.islocalenabled !== true) {
        return true;
      }
      if (localApproved && wf.isregionalenabled !== true) {
        return true;
      }
      return false;
    },
  },
  methods: {
    emitOpenWorkflows() {
      this.$emit('open-workflows-dialog');
    },
    emitOpenUserList() {
      this.$emit('open-user-list');
    },
    emitOpenCustomFilters() {
      this.$emit('open-custom-filters');
    },
    emitOpenStatusHelp() {
      this.$emit('open-status-help');
    },
    emitSelectAllFilters() {
      this.$emit('select-all-filters');
    },
    emitToggleView() {
      this.$emit('toggle-view');
    },
    emitGetPreviousCycleList() {
      this.$emit('get-previous-cycle-list');
    },
    emitPerformBulkTask(action) {
      this.$emit('perform-bulk-task', {}, action);
    },
    emitPreviewBulkCommentary() {
      this.$emit('preview-bulk-commentary');
    },
    emitDownloadExcel() {
      this.$emit('download-excel');
    },
    emitGetPdf() {
      this.$emit('get-pdf');
    },
    emitBulkCommentaryDialogueOpen() {
      this.$emit('bulk-commentary-dialogue-open');
    },
    emitBulkCommentaryDialogueOpenApprover() {
      this.$emit('bulk-commentary-dialogue-open-approver');
    },
    emitBulkApproveDialogueOpen() {
      this.$emit('bulk-approve-dialogue-open');
    },
    handleMarkRead() {
      this.$emit('mark-conversation-read');
    },
    goToPreviousPage() {
      if (this.page > 1) {
        this.$emit('page-change', this.page - 1);
      }
    },
    goToNextPage() {
      if (this.page < this.pagecount) {
        this.$emit('page-change', this.page + 1);
      }
    },
  },
};
</script>
